import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('stampede', {
  cherry: 'cowboy_hat',
  lemon: 'canteen',
  orange: 'cactus',
  bell: 'cowbell',
  star: 'bison_wild',
  seven: 'longhorn_skull',
  gem: 'turquoise',
  scatter: 'wagon_wheel_scatter',
  money: 'trail_hoard',
});

/** Stampede — GENERATED by scaffoldSlot from
 *  content/slots/stampede.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const STAMPEDE_THEME: Theme = {
  id: 'stampede',
  name: 'Stampede',
  palette: {
    accent: 0x9a6b3f,
    secondary: 0xc89a64,
    warm: 0xf2d27a,
    frameFill: 0x271a10,
    bgGradientTop: 0x46301c,
    bgGradientBottom: 0x18100a,
    dimOverlay: 0x0b0705,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Cowboy Hat', glyph: '🤠', tint: 0x8a5a3a, weight: 5, textureAlias: 'stampede:cherry',
        winVideoAlias: 'stampede:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Canteen', glyph: '🧴', tint: 0xc0a060, weight: 5, textureAlias: 'stampede:lemon',
        winVideoAlias: 'stampede:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Cactus', glyph: '🌵', tint: 0x4a7a3a, weight: 4, textureAlias: 'stampede:orange',
        winVideoAlias: 'stampede:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Cowbell', glyph: '🔔', tint: 0xd0a84e, weight: 3, textureAlias: 'stampede:bell',
        winVideoAlias: 'stampede:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Stampede', glyph: '🐃', tint: 0x6a4a32, weight: 2, textureAlias: 'stampede:star',
        winVideoAlias: 'stampede:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Longhorn', glyph: '💀', tint: 0xd8d0c0, weight: 2, textureAlias: 'stampede:seven',
        winVideoAlias: 'stampede:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Turquoise', glyph: '💎', tint: 0x4fc0c0, weight: 2.5, textureAlias: 'stampede:gem',
        winVideoAlias: 'stampede:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Wagon Wheel', glyph: '🛞', tint: 0x9a6b3f, weight: 0.5, textureAlias: 'stampede:scatter',
        winVideoAlias: 'stampede:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Trail Hoard', glyph: '💰', tint: 0xf0c860, weight: 1, textureAlias: 'stampede:money',
        winVideoAlias: 'stampede:money:win:video', winVideoSpeed: 2, isMoney: true },
      // Gem-on-reel — producer brief 2026-06-04. Scatter-style bonus
      // shared across every biome (registered via SHARED_REEL_SYMBOLS
      // in themes/index.ts). Weights deliberately rare so a gem
      // landing feels like a treat rather than background noise.
      { id: 'gem_t5',  label: 'Gems',     glyph: '💎', tint: 0x3ea7e8, weight: 0.10, gemValue: 5,  textureAlias: 'shared:reel:gem_5' },
      { id: 'gem_t10', label: 'Gem Pile', glyph: '💎', tint: 0x3ea7e8, weight: 0.05, gemValue: 10, textureAlias: 'shared:reel:gem_10' },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x271a10, multiplier: 0, weight: 3 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0x9a6b3f, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 4 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0xc89a64, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0x9a6b3f, multiplier: 1, weight: 4 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x271a10, multiplier: 0, weight: 2 },
      { id: 'x3-b', kind: 'multiplier', label: '×3', tint: 0xc89a64, multiplier: 3, weight: 3 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0x9a6b3f, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x15-a', kind: 'multiplier', label: '×15', tint: 0xf2d27a, multiplier: 15, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'stampede:bg', path: 'environment/stampede.png' },
      columnBackground: { alias: 'stampede:column_bg', path: 'reel/stampede_column_bg.png' },
      border: { alias: 'stampede:border', path: 'brand/border_frontier.png' },
    },
  },
};
